var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.376 26.3999C23.76 26.7359 24.288 26.7359 24.672 26.3999L38.256 13.8239C38.496 13.3439 38.448 12.5759 37.488 12.5759L10.608 12.6239C9.88799 12.6239 9.31199 13.2959 9.83999 13.8719L23.376 26.3999ZM38.4 19.1999C38.4 18.5759 37.632 18.2399 37.2 18.6719L26.64 28.4639C25.92 29.1359 25.008 29.4719 24.048 29.4719C23.088 29.4719 22.176 29.1359 21.456 28.4639L10.848 18.6719C10.7449 18.5797 10.6175 18.5192 10.481 18.4975C10.3444 18.4758 10.2045 18.4938 10.078 18.5495C9.95141 18.6052 9.84357 18.6961 9.76732 18.8115C9.69107 18.9268 9.64964 19.0617 9.64799 19.1999V31.6799C9.64799 33.2639 10.944 34.5599 12.528 34.5599H35.568C37.152 34.5599 38.448 33.2639 38.448 31.6799L38.4 19.1999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e94d95109ea78a51046f8e300f5f7d3d.svg";
export { ForwardRef as ReactComponent };